import { useContext, useMemo } from "react";

import { DataContext } from "contexts/Data";
import { filterVariants } from "helpers/variant";

import type { Variant, VariantOptions } from "types/app";

/**
 * Only use this hook under DataContext
 */
export default function useVariantsFilter(
  options: VariantOptions<string> = {},
  strict = true,
): Variant[] {
  const { variants } = useContext(DataContext);

  return useMemo(() => {
    if (!variants) return [];

    return filterVariants(variants, options, strict);
  }, [variants, options, strict]);
}
